function sortProductCards(parentClass, cardsClass) {
  const parentElements = document.querySelectorAll(`.${parentClass}`);
  parentElements.forEach((parent) => {
    if (!parent) {
      return;
    }

    const cards = Array.from(parent.querySelectorAll(`.${cardsClass}`));

    if (cards.length === 0) {
      return;
    }

    cards.sort((a, b) => {
      const aAvailable = a.querySelector('.product-available').value === 'true';
      const bAvailable = b.querySelector('.product-available').value === 'true';
      const aPrime = a.querySelector('.product-prime').value === 'true';
      const bPrime = b.querySelector('.product-prime').value === 'true';

      if ((aAvailable || aPrime) && !(bAvailable || bPrime)) return -1;
      if (!(aAvailable || aPrime) && (bAvailable || bPrime)) return 1;

      return 0;
    });

    cards.forEach((card) => card.remove());

    cards.forEach((card) => {
      parent.appendChild(card);
    });
  });
}

window.addEventListener('load', () => {
  setTimeout(() => sortProductCards('product-grid-container-list', 'product-card-container'), 300);
})